import React from "react";
import { Helmet } from "react-helmet";
import { ticketsVideoData } from "../../shared/ticketsVideoData";

function HelmetTickets(props) {
  const year = new Date().getFullYear();

  function generateTitle() {
    if (
      props.categoryTickets === "examAB" ||
      props.categoryTickets === "examCD"
    )
      return `${props.currentTicket.header} ПДД РФ | В${props.paramsTaskId}`;
    else if (
      props.categoryTickets === "ticketsAB" ||
      props.categoryTickets === "ticketsCD" ||
      props.categoryTickets === "themeAB"
    )

      return `${props.currentTask.question} | ПДД ${year} РФ | Категория ${props.categoryTickets.slice(
        props.categoryTickets.length - 2,
        props.categoryTickets.length
      )}. ${props.currentTicket.header}. Вопрос № ${props.paramsTaskId}`;

    else if (
      props.categoryTickets === "errorsAB" ||
      props.categoryTickets === "errorsCD"
    )
      return `Ошибки ${props.categoryTickets.slice(
        props.categoryTickets.length - 2,
        props.categoryTickets.length
      )} | ${props.currentTicket.header} | В${props.paramsTaskId}`;
    else if (props.categoryTickets === "newAB") {
      return `Новый вопрос | ${props.currentTask.question} Категория ABM ПДД РФ ${year}: Тесты, Экзамен, Теория, Дорожные Знаки и Разметка`;
    }
    else if (props.categoryTickets === "newCD")
    return `Новый вопрос | ${props.currentTask.question} Категория CD ПДД РФ ${year}: Тесты, Экзамен, Теория, Дорожные Знаки и Разметка`;
  }

  function generateDescription(og) {
    if (
      props.categoryTickets === "examAB" ||
      props.categoryTickets === "examCD" ||
      props.categoryTickets === "errorsAB" ||
      props.categoryTickets === "errorsCD"
    )
      return og ? (
        <meta
          property="og:description"
          content={`Пройдите онлайн тесты, подготовьтесь к экзамену в ГАИ. Ознакомьтесь с последними изменениями в Правилах Дорожного Движения России на ${year} год.  Освежите знания по теории и дорожным знакам. Помогаем подготовиться к сдаче экзамена на водительские удостоверение!`}
        />
      ) : (
        <meta
          name="description"
          content={`Пройдите онлайн тесты, подготовьтесь к экзамену в ГАИ. Ознакомьтесь с последними изменениями в Правилах Дорожного Движения России на ${year} год.  Освежите знания по теории и дорожным знакам. Помогаем подготовиться к сдаче экзамена на водительские удостоверение!`}
        />
      );
    else if (
      props.categoryTickets === "ticketsAB" ||
      props.categoryTickets === "ticketsCD" ||
      props.categoryTickets === "newAB" ||
      props.categoryTickets === "newCD"
    ) {
      return og ? (
        <meta
          property="og:description"
          content={"Ответ: " +
            props.currentTask.answers[props.currentTask.rightAnswer] +
            " Объяснение: " + props.currentTask.hint +
            " Вопросы для экзамена ПДД РФ с комментариями. Онлайн тесты, теория, дорожные знаки и разметка."
          }
        />
      ) : (
        <meta
          name="description"
          content={"Ответ: " +
            props.currentTask.answers[props.currentTask.rightAnswer] +
            " Объяснение: " + props.currentTask.hint +
            " Вопросы для экзамена ПДД РФ с комментариями. Онлайн тесты и теория, дорожные знаки и разметка."
          }
        />
      );
    }
    else if (
      props.categoryTickets === "themeAB"
    ) {
      return og ? (
        <meta
          property="og:description"
          content={"Ответ: " +
            props.currentTask.answers[props.currentTask.rightAnswer] +
            " Комментарий: " + props.currentTask.hint +
            " Вопросы по темам для экзамена ПДД РФ с комментариями. Онлайн тесты, теория, дорожные знаки и разметка."
          }
        />
      ) : (
        <meta
          name="description"
          content={"Ответ: " +
            props.currentTask.answers[props.currentTask.rightAnswer] +
            " Комментарий: " + props.currentTask.hint +
            " Вопросы по темам для экзамена ПДД РФ с комментариями. Онлайн тесты и теория, дорожные знаки и разметка."
          }
        />
      );
    }
  }

  function generateOgImg() {
    if (
      props.categoryTickets === "ticketsAB" ||
      props.categoryTickets === "ticketsCD"
    )
      return props.currentTask.img ? (
        <meta
          property="og:image"
          content={`https://pddportal.ru${props.currentTask.img}`}
        ></meta>
      ) : (
        <meta
          property="og:image"
          content="https://pddportal.ru/images/icons/logo192.png"
        ></meta>
      );
    else {
      return (
        <meta
          property="og:image"
          content="https://pddportal.ru/images/icons/logo192.png"
        ></meta>
      );
    }
  }

  function generateOgVideo() {
    if (
      props.categoryTickets === "ticketsAB"
    )
      return (
        <meta
          property="og:video"
          content={`${ticketsVideoData[props.currentTicket.ticketId - 1].src}`}
        ></meta>
      );
  }

  function generateCononical() {
    if (
      props.categoryTickets === "examAB" ||
      props.categoryTickets === "examCD" ||
      props.categoryTickets === "newAB" ||
      props.categoryTickets === "newCD"
    ) return (
      <link
        rel="canonical"
        href={`https://pddportal.ru/${props.categoryTickets}/${props.paramsTaskId}/`}
      />
    )
    else if (
      props.categoryTickets === "errorsAB" ||
      props.categoryTickets === "errorsCD"
    ) return (
      <link
        rel="canonical"
        href={`https://pddportal.ru/${props.categoryTickets}/${props.currentTicket.ticketId}/${props.paramsTaskId}/`}
      />
    )
    else if (
      props.categoryTickets === "themeAB"
    )
      return (
        <link
          rel="canonical"
          href={`https://pddportal.ru/${props.categoryTickets}/${props.currentTicket.ticketId}/${props.paramsTaskId}/`}
        />
      );
    else if (
      props.categoryTickets === "ticketsAB" ||
      props.categoryTickets === "ticketsCD"
    )
      return (
        <link
          rel="canonical"
          href={`https://pddportal.ru/${props.categoryTickets}/${props.currentTicket.ticketId}/${props.paramsTaskId}/`}
        />
      );
  }

  return (
    <Helmet>
      <title>
        {generateTitle()}
      </title>
      <meta property="og:title" content={generateTitle()} />
      {generateDescription()}
      {generateDescription(true)}
      {generateOgImg()}
      {generateCononical()}
      {generateOgVideo()}
    </Helmet>
  );
}

export default HelmetTickets;
